import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import Vue from 'vue'
import Vuex from 'vuex'
import store from '../vuex/store.js'
import config from './config'

Vue.use(Vuex)

// 图片上传方法
export const uploadPhoto = url => {
  return config.uploadUrl + '/postFile?dir=Images'
}
export const baseUrl = url => {
  return config.baseUrl + url
}
// 图片访问地址
export const filesDownload = url => {
  if (typeof url === 'object') {
    return config.resourceUrl + url.data
  }
  return config.resourceUrl + url
}

// pdf访问地址
export const filePdf = filePdf => {
  return config.resourceUrl + filePdf
}

export const pathUrl = pathUrl => {
  return '/caetn-web-service' + pathUrl
}
export const pathUrlIsLogin = pathUrlIsLogin => {
  return '/admin-auth-service' + pathUrlIsLogin
}
export const pathRegister = pathRegister => {
  return '/comuser-service' + pathRegister
}

// 创建axios实例
export const fetch = axios.create({
  baseURL: config.baseUrl,
  timeout: 15000,
  'Content-Type': 'application/x-www-form-urlencoded'
  // 'Access-Control-Allow-Origin': '*'
})

// 添加请求拦截器
fetch.interceptors.request.use(
  config => {
    config.headers['Token_'] = sessionStorage.token || ''
    // config.headers['Token_'] = encodeURI(encodeURI(sessionStorage.token)) || ''
    // 在发送请求之前做些什么
    // loading()

    return config
  },
  error => {
    // 对请求错误做些什么
    Message({
      message: '网络服务错误，请稍后尝试',
      type: 'error',
      duration: 5 * 1000,
      showClose: true
    })
    return Promise.reject(error)
  }
)
// 添加响应拦截器
fetch.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    // if(response.headers['codekey']){
    //   document.cookie = `codekey=${response.headers['codekey']}`
    // }
    const res = response.data
    if (res.code === '-104') {
      store.commit('userShow', false)
      sessionStorage.clear()
      Message('您的账号在其他终端登录，请确认并重新登录')
      setTimeout(() => {
        location.href = '/#' + config.enterpriseNumber
      }, 2000)
    }
    if (res.code === '-101') {
      store.commit('userShow', false)
      sessionStorage.clear()
      Message(res.message)
      setTimeout(() => {
        location.href = '/#' + config.enterpriseNumber
      }, 2000)
    }
    return response.data
  },
  error => {
    MessageBox.alert('网络错误，请稍后尝试或联系网站管理员', '温馨提示', {
      confirmButtonText: '知道了',
      type: 'warning'
    })
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

// 创建图片上传axios实例
export const uploadImage = axios.create({
  baseURL: config.uploadUrl + '/postFile?dir=caetn',
  timeout: 120000,
  headers: {
    // 这里可设置所有的请求头
    'Content-Type': 'multipart/form-data' // 该项建议设置 如果未 POST请求时 数据未做处理时会出现错误，最理想的解决方法就是 直接设置该项
  }
})

uploadImage.interceptors.request.use(config => {
  config.headers['Token_'] = sessionStorage.token || ''
  // 在发送请求之前做些什么
  return config
},
error => {
  // 对请求错误做些什么
  Message({
    message: '网络服务错误，请稍后尝试',
    type: 'error',
    duration: 5 * 1000,
    showClose: true
  })
  return Promise.reject(error)
}
)

// 添加响应拦截器
uploadImage.interceptors.response.use(response => {
  // 对响应数据做点什么
  const res = response.data
  // code为0是抛错
  if (res.code === '0') {
    Message({
      message: res.message,
      type: 'error',
      duration: 5 * 1000,
      showClose: true
    })
    return Promise.reject(res.message)
  } else if (res.code === '-100') {
    // 登录超时或未获取到token
    sessionStorage.token = ''
    Message({
      message: res.message,
      type: 'error',
      duration: 1 * 1000,
      showClose: true,
      onClose: function () {
        // location.reload()
      }
    })
    return Promise.reject(res.message)
  } else if (res.code === '3') {
    // 权限已过期
    Message({
      message: res.message,
      duration: 1 * 1000,
      showClose: true,
      onClose: function () {
        // // location.reload()
      }
    })
    return Promise.reject(res.message)
  } else {
    return response.data
  }
},
error => {
  //
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
}
)



// WEBPACK FOOTER //
// ./src/utils/index.js